import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './Empowering.css';
import Heading from '../../../utls/Heading';

const Empowering = () => {
  return (
    <>
        <div className="container  EmpoweringSection ">
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                    <Heading className='customheadings'><span>Empowering</span> Your Business Journey, Every Step of the Way</Heading>
                    <p className='firstPara mt-2 mt-xxl-3 pe-2 pe-md-0 mb-1 mb-md-3'>With over a decade of experience in the travel industry, Blueberry Travel is proud to announce its excellent travel management and unmatched service. We offer the best-customized packages and additional benefits aligned to your business meeting and goals. For smooth processing, our expert staff will contact you to ensure your travel requirements are satisfied.
                    </p>
                    <p className='secondPara pe-md-2 pe-md-0 mb-1 mb-md-3'>From booking flight tickets, holiday packages, and car rentals to sightseeing, make your travel experience better by choosing Blueberry Travel as your trusted partner. Business travel should be as pleasurable and productive as possible. 
                    </p>
                    <p className='secondPara pe-md-2 pe-md-0'>So, we are here to simplify your business trip by bringing travel management systems into practice. Our corporate travel consultants are well aware of all the hardships that can arise while traveling for business. Hence, we can firmly collaborate with your company to create a travel policy that is especially aligned with their prerequisites.</p>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Empowering